import axios from 'axios'
import * as Util from '@/vuex/util'

let defaultState = {
  amounts: [],
  average: '',
  total: ''
}

const state = {
  monthlyCollisions: defaultState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.monthlyCollisions = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.amount = defaultState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.monthlyCollisions.amounts,
  average: state => state.monthlyCollisions.avg,
  total: state => state.monthlyCollisions.total
}

export const MonthlyCollisions = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}




// WEBPACK FOOTER //
// ./src/vuex/modules/lineCharts/MonthlyCollisions.js